import { useContext } from 'react';

import { RffFormContext } from '../_providers';

export const useRffFormState = () => useContext(RffFormContext);
